// @flow
import type { Dispatch } from 'redux';
import type { BannerAction } from '../types/actions';
import type { AppBanner } from '../types/banner';

import userService from '../services/user-service';

function removeBannerAction(bannerName: string): BannerAction {
  return { type: 'REMOVE_BANNER_DB', bannerName };
}

function removeBannerActionDB(bannerName: string): BannerAction {
  return { type: 'REMOVE_BANNER', bannerName };
}

function removeBannerSuccess(bannerName: string, response): BannerAction {
  return { type: 'REMOVE_BANNER_SUCCESS', bannerName, response };
}

function removeBannerError(error: string): BannerAction {
  return { type: 'REMOVE_BANNER_ERROR', error };
}

function addBannerAction(banner: AppBanner): BannerAction {
  return { type: 'ADD_BANNER', banner };
}

function clearBannersAction(): BannerAction {
  return { type: 'CLEAR_BANNERS' };
}

const addBanner = (bannerKey: string, bodyParams: string[] = [], titleParams: string[] = []) => {
  return ((dispatch: Dispatch) => {
    dispatch(clearBannersAction());
    dispatch(addBannerAction({ bannerKey, bodyParams, titleParams }));
  });
};

const removeBanner = (bannerName: string) => {
  return ((dispatch: Dispatch) => {
    dispatch(removeBannerAction(bannerName));
  });
};

const clearBanners = () => {
  return ((dispatch: Dispatch) => {
    dispatch(clearBannersAction());
  });
};

const removeBannerDB = (bannerName: string) => {
  return (dispatch: Dispatch) => {
    dispatch(removeBannerActionDB(bannerName));
    userService
      .removeBanner(bannerName)
      .then((response) => {
        dispatch(removeBannerSuccess(bannerName, response));
      })
      .catch((err) => {
        dispatch(removeBannerError(err));
      });
  };
};

export { removeBannerDB, removeBanner, addBanner, clearBanners };


// WEBPACK FOOTER //
// ./src/actions/banners.js